import { isValidElement, useEffect, useState } from 'react';
import { PaginationRequest } from '../../clients/quipli-service/pagination/pagination';
import { DataTableColumn, DataTableProps, DataTableRow } from './data-table';
import { Spinner } from '../spinner/spinner';
import { Typography } from '../typography/typography';
import classNames from 'classnames';
import { Paginator } from '../paginator/paginator-v2';
import Icon from '../icons/icon';

export const MobileDataTable = <TPaginator extends PaginationRequest>({
  data,
  tabs,
  columnNames,
  noDataText = 'No data available',
  isLoading,
  pagination,
  request,
  setRequest,
  cypressPrevious,
  cypressNext,
}: DataTableProps<TPaginator>) => {
  const [openMobileRow, setOpenMobileRow] = useState<number | null>(null);

  useEffect(() => {
    setOpenMobileRow(null);
  }, [pagination, data]);

  return (
    <div className="bg-white">
      {tabs && tabs}
      {data.length === 0 || isLoading ? (
        isLoading ? (
          <Spinner />
        ) : (
          <Typography type="text-sm" className="text-grey-500 flex items-center justify-center min-h-[100px]">
            {noDataText}
          </Typography>
        )
      ) : (
        data.map((elem: DataTableRow, idx: number) => {
          return (
            <div key={idx} className="mobile-datatable-borders">
              <div
                id={`mobile-table-row-${idx}`}
                key={idx}
                className="bg-white p-[16px] flex justify-between items-center"
              >
                <div>{elem.mobileHeader}</div>
                {elem.mobileHeaderAction ? (
                  <div>{elem.mobileHeaderAction}</div>
                ) : (
                  <div
                    onClick={() => {
                      document.getElementById(`mobile-table-row-${idx}`)?.scrollIntoView();
                      setOpenMobileRow((prevValue) => (prevValue === idx ? null : idx));
                    }}
                  >
                    <Icon icon="ChevronDown" />
                  </div>
                )}
              </div>
              <div
                key={`content-${idx}`}
                className={classNames('hidden bg-white p-[16px] flex-wrap collapse-transition', {
                  '!flex': openMobileRow === idx,
                })}
              >
                {columnNames.map(
                  (
                    {
                      label,
                      key,
                      isCheckBoxColumn,
                      showRule = 'Both',
                      mobileShowRule = 'fullrow',
                      hide = false,
                    }: DataTableColumn,
                    idx: number,
                  ) => {
                    return (
                      !isCheckBoxColumn &&
                      !hide &&
                      showRule !== 'OnlyDesktop' && (
                        <div
                          key={idx}
                          className={classNames('w-full min-h-[52px] flex', {
                            'mobile-datatable-borders': columnNames.length !== idx + 1 && mobileShowRule !== 'halfrow',
                            'flex-[0_1_50%] my-[5px]': mobileShowRule === 'halfrow',
                          })}
                        >
                          {mobileShowRule === 'fullrow' ? (
                            <>
                              {label && (
                                <div className="flex-[0_1_50%] flex items-center">
                                  <Typography type="text-md" className="text-grey-500">
                                    {label !== undefined ? label : key}
                                  </Typography>
                                </div>
                              )}

                              <div
                                className={classNames('flex items-center', {
                                  'flex-[0_1_50%]': label,
                                  'flex-[0_1_100%] justify-center': !label,
                                })}
                              >
                                {isValidElement(elem.fields[key]) ? (
                                  elem.fields[key]
                                ) : (
                                  <Typography type="text-sm" className="text-quipli-black-800">
                                    {elem.fields[key]}
                                  </Typography>
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              {
                                <div className="flex-[0_1_50%] flex flex-col justify-start">
                                  <Typography type="text-md" className="text-grey-500">
                                    {label !== undefined ? label : key}
                                  </Typography>
                                  {isValidElement(elem.fields[key]) ? (
                                    elem.fields[key]
                                  ) : (
                                    <Typography type="text-sm" className="text-quipli-black-800">
                                      {elem.fields[key]}
                                    </Typography>
                                  )}
                                </div>
                              }
                            </>
                          )}
                        </div>
                      )
                    );
                  },
                )}
              </div>
            </div>
          );
        })
      )}

      {setRequest && pagination && (
        <Paginator
          request={request}
          setRequest={(paginator) => setRequest((prev) => ({ ...prev, ...paginator }))}
          pagination={pagination}
          cypressPrevious={cypressPrevious}
          cypressNext={cypressNext}
        />
      )}
    </div>
  );
};
